<template>
    <div class="ah-page invoice-page" @click="onPageClick">
        <div class="page-header" id="invoice-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title" style="display: flex; align-items: center">
                        <h1>發票</h1>
                        <el-tooltip class="item" effect="dark" content="發票開立年份（如尚未開立以建立日期查詢）" placement="top">
                            <el-select v-model="yearSelect" class="title-dropdown">
                                <el-option v-for="item in yearList" :key="item.key" :value="item.value" :label="item.label"></el-option>
                            </el-select>
                        </el-tooltip>
                    </div>
                    <div class="actions">
                        <el-input
                            v-model="queryParams.IooOrFOO"
                            class="search"
                            placeholder="發票號碼、單號、客戶"
                            prefix-icon="el-icon-search"
                            :clearable="true"
                            style="margin-right: 10px"
                            @keyup.enter.native="onSimpleSearchKeyUp"
                            @clear="updateData(true)"
                        ></el-input>
                        <el-button type="dark-transparent" round @click="isShowFilter = isShowFilter ? false : true" icon="el-icon-zoom-in"></el-button>
                        <el-button type="normal" :loading="isLoadingExport" @click="onExport">
                            {{ selectedDatas.length > 0 ? `匯出Excel（${selectedDatas.length}筆）` : '匯出Excel' }}
                        </el-button>
                        <el-button type="highlight" v-if="isAuth('B01')" @click="handleAddBtnClick">申請開發票</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <transition enter-active-class="animate__animated animate__fadeIn">
                    <div class="ah-card adv-search-card" v-if="isShowFilter">
                        <div class="title">進階搜尋</div>
                        <div class="content">
                            <el-form ref="form" :model="queryParams" label-width="220px" label-position="right" size="small">
                                <el-form-item label="關鍵字">
                                    <el-input v-model="queryParams.IooOrFOO" placeholder="單號、發票號碼" style="max-width: 400px" />
                                </el-form-item>
                                <el-form-item prop="typ" label="發票類型">
                                    <el-select v-model="queryParams.types" filterable reserve-keyword multiple>
                                        <el-option v-for="item in invoiceType" :key="item.key" :label="item.value" :value="item.key" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="hasEInvoiceService" label="發票開立方式">
                                    <el-radio-group v-model="queryParams.EInvoice">
                                        <el-radio :label="null">不限</el-radio>
                                        <el-radio :label="true">電子發票</el-radio>
                                        <el-radio :label="false">一般手開</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="建單日期">
                                    <el-date-picker
                                        v-model="queryParams.createQueryDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <template slot="label">
                                        開立日期
                                        <ah-tip>發票開立日期（如尚未開立以預計發票日期查詢）</ah-tip>
                                    </template>
                                    <el-date-picker
                                        v-model="queryParams.queryDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="預計收款日">
                                    <el-date-picker
                                        v-model="queryParams.queryPdatDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="typ" label="發票作廢狀態">
                                    <el-radio-group v-model="queryParams.FOO_DIS_CNL">
                                        <el-radio :label="null">不限</el-radio>
                                        <el-radio :label="true">已作廢</el-radio>
                                        <el-radio :label="false">未作廢</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="客戶">
                                    <el-select
                                        v-model="queryParams.VendorId"
                                        style="min-width: 350px"
                                        filterable
                                        reserve-keyword
                                        remote
                                        clearable
                                        :placeholder="companyInfo.displayClient ? '請選擇' : '請輸入客戶關鍵字（至少兩個字）'"
                                        :no-data-text="companyInfo.displayClient ? '無資料' : '無匹配資料'"
                                        :remote-method="vendorRemoteMethod"
                                        @change="handleVendorChange"
                                        @keydown.native.capture.enter="preventIMESelect"
                                    >
                                        <el-option :value="item.sno" :label="item.fnam" v-for="item in vendorOptions" :key="item.sno"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="專案">
                                    <el-select
                                        v-model="queryParams.ProjectId"
                                        style="min-width: 350px"
                                        filterable
                                        reserve-keyword
                                        remote
                                        clearable
                                        :placeholder="companyInfo.displayProject ? '請選擇' : '請輸專案關鍵字（至少兩個字）'"
                                        :no-data-text="companyInfo.displayProject ? '無資料' : '無匹配資料'"
                                        :remote-method="projectRemoteMethod"
                                        @keydown.native.capture.enter="preventIMESelect"
                                    >
                                        <el-option :value="item.sno" :label="item.nam" v-for="item in projectOptions" :key="item.sno"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="申請人">
                                    <el-select v-model="queryParams.Creators" filterable reserve-keyword multiple>
                                        <el-option v-for="item in creatorOptions" :key="item.sno" :value="item.sno" :label="item.onf ? item.nam : `${item.nam}（已停用）`" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="入帳日期">
                                    <el-date-picker
                                        v-model="queryParams.queryReceiveDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="入帳銀行帳戶">
                                    <ahElSelectBankAccount v-model="queryParams.bankSnos" multiple></ahElSelectBankAccount>
                                </el-form-item>
                                <el-form-item label="退款日期">
                                    <el-date-picker
                                        v-model="queryParams.queryRefundDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="銷貨折讓/作廢日期">
                                    <el-date-picker
                                        v-model="queryParams.queryReturnDate"
                                        type="daterange"
                                        range-separator="~"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :default-time="['00:00:00', '23:59:59']"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="itemSnos" label="收支項目">
                                    <ahSelectVariableStateItem ref="ahSelectVariableStateItem" v-model="queryParams.itemSnos" :enableType="['invoice']" :showTip="false" show-system-default multiple />
                                </el-form-item>
                                <el-form-item label="金額">
                                    <MoneyInput v-model="queryParams.AMT_Min" style="width: 130px" size="small" is-search />
                                    <span style="display: inline-block; width: 40px; text-align: center">~</span>
                                    <MoneyInput v-model="queryParams.AMT_Max" style="width: 130px; margin-right: 10px" size="small" is-search />
                                    <ahElSelectCny v-model="queryParams.cnyList" multiple />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" class="primary-action" @click="handleAdvSearchClick"> 查詢 </el-button>
                                    <el-button @click="handleAdvSearchClearClick(false)"> 清除 </el-button>
                                    <el-button @click="handleAdvSearchClearClick(true)"> 清空並返回 </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </transition>
            </div>
            <div v-loading="isStatisticLoading" class="ah-container invoice-page-statis" id="invoice-page-statis">
                <el-row :gutter="20">
                    <el-col :sm="6">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    未收金額
                                    <span class="percentage">
                                        {{ toBeCreditedPercentage }}
                                    </span>
                                    <ahTip> (發票含稅總計 - 銷貨折讓及退回) - 已收帳款 + 銷貨退款 </ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="computedToBeCreditedAmount" id="payment-page-to-be-credit-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amounts.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.totalAmount - item.incomingAmount + item.refundAmount - item.discountAmount">
                                            <Money :v="item.totalAmount - item.incomingAmount + item.refundAmount - item.discountAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny">
                                                約當台幣 <Money :v="item.totalAmountTwd - item.incomingAmountTwd + item.refundAmountTwd - item.discountAmountTwd" round />
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="8">
                        <div class="ah-card main-color summary-data">
                            <div class="content">
                                <div class="statis-title">
                                    已收帳款
                                    <span class="percentage">
                                        {{ incomingPercentage }}
                                    </span>
                                    <ahTip> 已入帳金額 </ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.incomingAmount" id="payment-page-credited-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amounts.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.incomingAmount">
                                            <Money :v="item.incomingAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.incomingAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="statis-title">
                                    銷貨退款
                                    <ahTip> 已入帳後退款給客戶的金額 </ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.refundAmount" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amounts.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.refundAmount">
                                            <Money :v="item.refundAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.refundAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="10">
                        <div class="ah-card main-color summary-data">
                            <div class="content">
                                <div class="statis-title">
                                    發票(含稅)總金額
                                    <span class="percentage">{{ amounts.totalAmount == 0 ? "--" : "100 %" }}</span>
                                    <ah-tip>
                                        <div>
                                            <InvoiceStatusLabel :statusNum="2" /> ＋
                                            <InvoiceStatusLabel :statusNum="3" />
                                        </div>
                                        <div style="font-size: 9pt; margin-top: 10px">（僅計算截至今日 ({{ todayText }}) 開立的發票）</div>
                                    </ah-tip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.totalAmount" id="payment-page-total-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amounts.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.totalAmount">
                                            <Money :v="item.totalAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.totalAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="statis-title">
                                    銷貨折讓及退回 (含稅)
                                    <ahTip>依搜尋發票結果中，有銷貨折讓退回的金額總計</ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="amounts.discountAmount" id="payment-page-total-amt" round />
                                    <span class="cny">TWD</span>
                                </div>
                                <div v-if="isShowCnys" class="cny-statistic statis-num">
                                    <div v-for="(item, i) in amounts.statisticalList" :key="`unpaid-${i}`" class="cny-statistic-block">
                                        <template v-if="item.discountAmount">
                                            <Money :v="item.discountAmount" />
                                            <span class="cny">{{ item.cny }}</span>
                                            <span v-if="item.cny !== 'TWD'" class="cny"> 約當台幣 <Money :v="item.discountAmountTwd" round /></span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="page-statis-actions" style="display: flex; justify-content: end; align-items: center; gap: 15px;">
                    <div style="color: #fff;">
                        <ahMiniSwitch v-model="queryParams.ExcludeFutureDate" name="截至今日開立" @change="updateData(true)" />
                    </div>
                    <el-button size="small" type="primary" @click="onShowCnysClick">
                        {{ isShowCnys ? "隱藏外幣" : "顯示所有幣別" }}
                    </el-button>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel" style="margin-top: 25px">
                <div style="padding: 10px">
                    <div class="ah-tabs right">
                        <!-- 全部 -->
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.Status === null,
                            }"
                            @click="fetchData(null)"
                            @keydown="() => {}"
                        >
                            <span class="name">全部</span>
                            <span class="count">{{ counts.fullTotal }}</span>
                        </div>
                        <!-- 待審核 -->
                        <div
                            :class="{
                                item: true,
                                active: queryParams.Status === 0,
                            }"
                            @click="fetchData(0)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="0" :count="counts.progrsingTotal" />
                            </span>
                            <span class="total">
                                <Money :v="amounts.progrsingAmount" round />
                            </span>
                        </div>
                        <!-- 待開立 -->
                        <div
                            :class="{
                                item: true,
                                active: queryParams.Status === 1,
                            }"
                            @click="fetchData(1)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="1" :count="counts.toBeCreateTotal" />
                            </span>
                            <span class="total">
                                <Money :v="amounts.toBeCreateAmount" round />
                            </span>
                        </div>
                        <!-- 待入帳 -->
                        <div
                            :class="{
                                item: true,
                                active: queryParams.Status === 2,
                            }"
                            @click="fetchData(2)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="2" :count="counts.toBeCreditedTotal" />
                            </span>
                            <span class="total">
                                <Money :v="amounts.toBeCreditedAmount" round />
                            </span>
                        </div>
                        <!-- 完成 -->
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.Status === 3,
                            }"
                            @click="fetchData(3)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="3" :count="counts.creditedTotal" />
                            </span>
                        </div>
                        <!-- 退件 -->
                        <div
                            :class="{
                                item: true,
                                active: queryParams.Status === 4,
                            }"
                            @click="fetchData(4)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="4" :count="counts.rejectTotal" />
                            </span>
                            <span class="total">
                                <Money :v="amounts.rejectAmount" round />
                            </span>
                        </div>
                        <!-- 作廢 -->
                        <div
                            :class="{
                                item: true,
                                'name-only': true,
                                active: queryParams.IsVoid === true,
                            }"
                            @click="fetchData(-1)"
                            @keydown="() => {}"
                        >
                            <span class="name no-padding">
                                <InvoiceStatusLabel :statusNum="5" />
                            </span>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <InvoiceTable
                        :datas="datas"
                        :status-query="queryParams.Status"
                        @detailClose="handleDetailDialogClose"
                        @sort-change="onSortChange"
                        @select-change="onTableRowSelect"
                        :loading="isLoading"
                        ref="dataTable"
                    />
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="handlePaginationChange"
                        class="pagination"
                        id="invoice-page-main-table"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { invoiceDatePeriod, invoiceType, datePickerOption } from '@/assets/commonData/options';
import ahTip from '@/components/ui/ahTip.vue';
import ahMiniSwitch from '@/components/ui/ahMiniSwitch.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import InvoiceStatusLabel from './InvoiceStatusLabel.vue';
import InvoiceTable from './InvoiceTable.vue';
import InvoicePageExportMixins from './InvoicePageExportMixins';

export default {
    name: 'InvoicePage',
    mixins: [InvoicePageExportMixins],
    components: {
        ahTip,
        ahMiniSwitch,
        InvoiceTable,
        InvoiceStatusLabel,
        ahElSelectCny,
        ahSelectVariableStateItem,
        ahElSelectBankAccount,
    },
    data() {
        return {
            isShowFilter: false,
            invoiceDatePeriod,
            invoiceType,
            isLoading: false,
            isStatisticLoading: false,
            showDatePeriodDialog: false,
            showAddDialog: false,
            datePeriodType: null,
            selectedSno: null,
            selectedDatas: [],
            queryParams: {
                IooOrFOO: null,
                PageNum: 1,
                PageSize: 25,
                StartDate: null,
                EndDate: null,
                CreateDateStartDate: null,
                CreateDateEndDate: null,
                BankStartDate: null,
                BankEndDate: null,
                VendorId: null,
                ProjectId: null,
                Status: null,
                FOO_DIS_CNL: null,
                types: null,
                AMT_Min: null,
                AMT_Max: null,
                Creators: [],
                bankSnos: [],
                itemSnos: [],
                cnyList: [],
                IsVoid: false,
                queryDate: null,
                createQueryDate: null,
                queryReceiveDate: null,
                queryPdatDate: null,
                PdatStartDate: null,
                PdatEndDate: null,
                EInvoice: null,
                ExcludeFutureDate: true,
            },
            prevQuery: {},

            OrderParam: {
                SortColumn: null,
                OrderBy: null,
            },

            datas: [],
            amounts: {
                fullTotal: null,
                progrsingTotal: null,
                toBeCreateTotal: null,
                rejectTotal: null,
                toBeCreditedTotal: null,
                creditedTotal: null,
                voidTotal: null,
            },
            counts: {
                totalAmount: null,
                rejectAmount: null,
                auditingAmount: null,
                toBeCreditedAmount: null,
                creditedAmount: null,
                pendingPaymentAmount: null,
                noFileAmount: null,
            },

            vendorOptions: [],
            projectOptions: [],
            creatorOptions: [],
            totalDataCount: 0,
            dateFilterValue: null,

            isLoadingExport: false,

            yearList: [],
            pickerOptions: datePickerOption,
            isShowCnys: false,
        };
    },
    computed: {
        isAhooAgent() {
            return this.$store.getters['account/isAhooAgent'];
        },
        computedToBeCreditedAmount() {
            return this.amounts.totalAmount - this.amounts.incomingAmount + this.amounts.refundAmount - this.amounts.discountAmount;
        },
        toBeCreditedPercentage() {
            const percent = this.computedToBeCreditedAmount / this.amounts.totalAmount;

            if (Number.isNaN(percent)) return '--';
            return `${Math.round(percent * 1000) / 10} %`;
        },
        incomingPercentage() {
            const percent = this.amounts.incomingAmount / this.amounts.totalAmount;

            if (Number.isNaN(percent)) return '--';
            return `${Math.round(percent * 1000) / 10} %`;
        },
        yearSelect: {
            set(val) {
                if (!val) {
                    this.queryParams.queryDate = null;
                    this.updateData(true);
                    return;
                }

                const sd = Number(moment().year(val).startOf('year').format('x'));
                const ed = Number(moment().year(val).endOf('year').format('x'));

                this.queryParams.queryDate = [sd, ed];
                this.updateData(true);
            },
            get() {
                if (!this.queryParams.queryDate) return '所有年份';
                const year = moment(Number(this.queryParams.queryDate[0])).year();
                const daysOfYear = year % 4 === 0 ? 366 : 365;
                const sd = moment(Number(this.queryParams.queryDate[0]));
                const ed = moment(Number(this.queryParams.queryDate[1]));

                // eslint-disable-next-line eqeqeq
                if (sd.format('DDD') == 1 && ed.format('DDD') == daysOfYear) {
                    return year;
                }
                return '自訂';
            },
        },
        hasEInvoiceService() {
            return this.$store.getters['menu/companyInfo'].eInvoice;
        },
        todayText() {
            return moment().format('YYYY-MM-DD');
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
    },
    mounted() {
        this.initYearSelect();
        this.updateData();
        this.fetchVendorOptions();
        this.fetchProjectOptions();
        this.fetchCreatorOptions();
        this.$store.dispatch('accounting/updateAccountingSettings');

        // 如果網址含有序號，自動開啟 detail dialog
        if (this.$route.params.sno) {
            this.$refs.dataTable.showDetail(this.$route.params.sno);
        }
    },
    methods: {
        initYearSelect() {
            const START = 2020;
            const END = moment().year() + 1;

            this.yearList = [];
            this.yearList.push({ label: '所有年份', value: null });
            for (let i = END; i >= START; i -= 1) {
                this.yearList.push({ label: i, value: i, key: `year-list-${i}-${+new Date()}` });
            }

            const sd = Number(moment().startOf('year').format('x'));
            const ed = Number(moment().endOf('year').format('x'));
            this.queryParams.queryDate = [sd, ed];
        },
        onSimpleSearchKeyUp() {
            if (!this.isShowFilter) this.queryParams.queryDate = null;
            this.updateData(true);
        },
        handleAdvSearchClick() {
            this.updateData(true);

            setTimeout(() => {
                this.scrollToId('invoice-page-statis', 'start');
            }, 300);
        },
        handleAdvSearchClearClick(resumeDefault) {
            this.queryParams = {
                IooOrFOO: null,
                types: null,
                PageNum: 1,
                PageSize: 25,
                StartDate: null,
                EndDate: null,
                VendorId: null,
                ProjectId: null,
                Status: null,
                AMT_Min: null,
                AMT_Max: null,
                Creators: [],
                bankSnos: [],
                itemSnos: [],
                cnyList: [],
                IsVoid: false,
                queryDate: null,
                createQueryDate: null,
                queryReceiveDate: null,
                queryPdatDate: null,
                EInvoice: null,
            };
            this.$refs.ahSelectVariableStateItem.clear();

            if (resumeDefault) {
                this.initYearSelect();
                this.isShowFilter = false;
                this.updateData(true);
            }

            this.scrollToId('invoice-page-header', 'start');
        },
        handleAddBtnClick() {
            this.$router.push({ name: 'invoice-add' });
        },

        handleVendorChange() {
            this.fetchProjectOptions();
        },

        handlePaginationChange() {
            this.updateData();
        },

        handleDetailDialogClose(refresh) {
            if (refresh) this.updateData();
        },
        onSortChange(event) {
            if (event.order === 'ascending') {
                this.OrderParam.OrderBy = 1;
            }
            if (event.order === 'descending') {
                this.OrderParam.OrderBy = 2;
            }
            if (event.order === null) {
                this.OrderParam.OrderBy = null;
            }
            this.OrderParam.SortColumn = event.prop;
            this.queryParams.PageNum = 1;
            this.updateData();
        },
        applyDateToQueryParams() {
            // 開立日期
            if (this.queryParams.queryDate) {
                const [startDate, endDate] = this.queryParams.queryDate;
                this.queryParams.StartDate = startDate;
                this.queryParams.EndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.StartDate = null;
                this.queryParams.EndDate = null;
            }
            // 建立日期
            if (this.queryParams.createQueryDate) {
                const [startDate, endDate] = this.queryParams.createQueryDate;
                this.queryParams.CreateDateStartDate = startDate;
                this.queryParams.CreateDateEndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.CreateDateStartDate = null;
                this.queryParams.CreateDateEndDate = null;
            }
            // 銷貨折讓/作廢日期
            if (this.queryParams.queryReturnDate) {
                const [startDate, endDate] = this.queryParams.queryReturnDate;
                this.queryParams.AllowanceStartDate = startDate;
                this.queryParams.AllowanceEndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.AllowanceStartDate = null;
                this.queryParams.AllowanceEndDate = null;
            }
            // 入帳日期
            if (this.queryParams.queryReceiveDate) {
                const [startDate, endDate] = this.queryParams.queryReceiveDate;
                this.queryParams.IncomingStartDate = startDate;
                this.queryParams.IncomingEndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.IncomingStartDate = null;
                this.queryParams.IncomingEndDate = null;
            }
            // 退款日期
            if (this.queryParams.queryRefundDate) {
                const [startDate, endDate] = this.queryParams.queryRefundDate;
                this.queryParams.RefundStartDate = startDate;
                this.queryParams.RefundEndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.RefundStartDate = null;
                this.queryParams.RefundEndDate = null;
            }
            // 預計收款日
            if (this.queryParams.queryPdatDate) {
                const [startDate, endDate] = this.queryParams.queryPdatDate;
                this.queryParams.PdatStartDate = startDate;
                this.queryParams.PdatEndDate = +moment(endDate).endOf('day').format('x');
            } else {
                this.queryParams.PdatStartDate = null;
                this.queryParams.PdatEndDate = null;
            }
        },

        async updateData(resetPageNum = false) {
            try {
                this.isLoading = true;

                if (resetPageNum) this.queryParams.PageNum = 1;

                this.applyDateToQueryParams();
                this.prevQuery = { ...this.queryParams };

                let params = { ...this.queryParams };
                if (this.OrderParam.SortColumn !== null && this.OrderParam.OrderBy !== null) {
                    params = { ...this.OrderParam, ...this.queryParams };
                }

                const { query, resetQuery } = this.getManualQuery(this.prevQuery);
                this.updateAmountTotalData(query, params, resetQuery);

                const resp = await this.$api({
                    url: `InvoiceManagemnetPage/QueryInvoice${query}`,
                    params: { ...params, ...resetQuery },
                    method: 'GET',
                });

                console.log('Invoices', resp.data);
                if (this.queryParams.PageNum !== 1 && !resp.data.totalNum) {
                    this.queryParams.PageNum -= 1;
                    this.updateData();
                    return;
                }
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
                this.counts = resp.data.invoceCounts;
            } finally {
                this.isLoading = false;
            }
        },
        async updateAmountTotalData(query, params, resetQuery) {
            try {
                this.isStatisticLoading = true;
                const respAmoutTotal = await this.$api({
                    url: `InvoiceManagemnetPage/QueryInvoiceAmoutTotal${query}`,
                    params: { ...params, ...resetQuery },
                    method: 'GET',
                });
                this.amounts = respAmoutTotal.data.amoutTotal;
            } finally {
                this.isStatisticLoading = false;
            }
        },
        fetchData(status) {
            if (status === -1) {
                this.queryParams.Status = null;
                this.queryParams.IsVoid = true;
            } else {
                this.queryParams.Status = status;
                this.queryParams.IsVoid = false;
            }
            this.OrderParam = {
                SortColumn: null,
                OrderBy: null,
            };
            this.$refs.dataTable.clearSort();

            this.updateData(true);
        },
        async fetchVendorOptions(query) {
            try {
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/GetVendorList',
                    method: 'GET',
                    params: { keyword: query },
                });
                this.vendorOptions = resp.data.items;
            } catch (e) {
                console.log(e);
            }
        },
        vendorRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchVendorOptions(query);
        },

        async fetchProjectOptions(query) {
            try {
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/GetProjectList',
                    method: 'GET',
                    params: { keyword: query, VDR_SNO: this.queryParams.VendorId },
                });
                this.projectOptions = resp.data.items;
            } catch (e) {
                console.log(e);
            }
        },
        projectRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchProjectOptions(query);
        },
        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },

        async fetchCreatorOptions() {
            const resp = await this.$api({
                url: '/InvoiceManagemnetPage/GetAgentIds',
                method: 'GET',
            });
            this.creatorOptions = _.chain(resp.data.items)
                .filter((x) => x.sno !== 1)
                .filter((o) => (this.isAhooAgent ? true : o.nam !== 'Ahoo專員'))
                .value();
        },
        onPageClick(event) {
            if (event.target.classList.contains('ah-page') || event.target.classList.contains('ah-container')) {
                this.$refs.dataTable.removeHighlight();
            }
        },
        onTableRowSelect(selection) {
            this.selectedDatas = selection;
        },

        getManualQuery(query) {
            const returnValue = [
                ..._.map(query.Creators, (o) => `Creators=${o}`),
                ..._.map(query.bankSnos, (o) => `bankSnos=${o}`),
                ..._.map(query.itemSnos, (o) => `itemSnos=${o}`),
                ..._.map(query.cnyList, (o) => `cnyList=${o}`),
                ..._.map(query.types, (o) => `type=${o}`),
            ];
            return {
                query: returnValue.length ? `?${returnValue.join('&')}` : '',
                resetQuery: {
                    Creators: undefined,
                    bankSnos: undefined,
                    itemSnos: undefined,
                    cnyList: undefined,
                    types: undefined,
                    queryDate: undefined,
                    createQueryDate: undefined,
                    queryRefundDate: undefined,
                    queryReceiveDate: undefined,
                    queryReturnDate: undefined,
                    queryPdatDate: undefined,
                },
            };
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        onShowCnysClick() {
            this.isShowCnys = !this.isShowCnys;
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.invoice-page {
    .amt-refund {
        color: red;

        .label {
            display: inline-block;
            border: 1px solid red;
            border-radius: 5px;
            padding: 0px 10px;
            margin-right: 10px;
        }
    }
    .amt-overflow {
        color: green;
    }

    .search {
        width: 250px;

        @media (max-width: 720px) {
            width: 150px;
        }
    }
    .summary-data {
        display: flex;
        > div {
            flex: 1;
        }
    }
    .cny-hint {
        position: relative;
        top: -10px;
        font-size: 10pt;
        color: #fff;
        opacity: 0.7;
    }

    $exclude-future-date-checked-color: #ff7300;
    .exclude-future-date-checkbox {
        color: white;
        &.is-checked {
            .el-checkbox__label {
                color: $exclude-future-date-checked-color;
            }
            .el-checkbox__inner {
                background-color: white;
                border-color: white;
                &::after {
                    border-color: $exclude-future-date-checked-color;
                    border-width: 1.5px;
                }
            }
        }
    }
}
.invoice-page-statis {
    .el-loading-mask {
        background-color: #463cb2b8;
    }
    .el-loading-spinner .path {
        stroke: #fff;
    }
}
</style>
